import { PersonRequest } from "@plinknz/tah-website-elements";
import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { getPhone, PhoneType } from "../../../utility/phone";

export function emergencyContactConfig(member: PersonRequest): PageConfig[] {
  const phone = getPhone({ phone: member?.phone, type: PhoneType.Home });
  const cell = getPhone({ phone: member?.phone, type: PhoneType.Cell });
  const defaultValue = cell?.value || phone?.value;

  return [
    {
      name: "emergencyContact",
      title: "Emergency Contact",
      questions: [
        {
          type: "text",
          title: "Emergency Contact",
          name: "emergencyContact",
          placeHolder: "Matua",
          isRequired: true,
        },
        {
          type: "text",
          title: "Relationship",
          name: "emergencyContactRelationship",
          placeHolder: "Hononga",
          isRequired: true,
        },
        {
          type: "text",
          title: "Contact Number In Case Of Emergency",
          name: "emergencyContactPhone",
          placeHolder: "Waea",
          defaultValue,
          isRequired: true,
        },
      ],
    },
  ];
}
